<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] Auto Reject Setting
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Created_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Create_By}}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edit_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edited_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Edit_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button :icon="mode == this.$FORM_MODE_DELETE ? 'pi pi-trash' : 'pi pi-save'"
                            :label="mode == this.$FORM_MODE_DELETE ? 'Delete' : 'Save'"
                            :class="mode == this.$FORM_MODE_DELETE ? 'p-button-danger' : 'p-button-success'"
                            @click="confirm($event)" v-if="mode != this.$FORM_MODE_VIEW" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm">
                    <div class="p-fluid">
                        <div class="field grid">
                            <label for="Company_Name" class="col-2">{{$t('company')}}</label>
                            <div class="col-6 md-6">
                                <CustomSelect v-model="header.Company_Code" class="p-inputtext-sm" v-if="header"
                                    :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{}"
                                    :disabled="isDisable" />
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>

                        <div class="field grid">
                            <label for="Business_Segment_Code" class="col-2">{{$t('product_category')}}</label>
                            <div class="col-6 md-6">
                                <InputText name="Format" v-model="header.Business_Segment_Code" type="text"
                                    placeholder="Product Category" v-if="header" :disabled="isDisable" />
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>

                        <div class="field grid">
                            <label for="Status" class="col-2">{{$t('status')}}</label>
                            <div class="col-6 md-6">
                                <!-- <InputText name="Status" v-model="header.Status" type="text" placeholder="Status"
                                    v-if="header" :disabled="isDisable" /> -->
                                <Dropdown v-model="header.Status"
                                        :options="optionStatus" optionLabel="label" optionValue="value"
                                        :placeholder="$t('status')" v-if="header" :disabled="isDisable" />
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>

                        <div class="field grid">
                            <label for="Tansporter_Status" class="col-2">{{$t('transporter_status')}}</label>
                            <div class="col-6 md-6">
                                <!-- <InputText name="Tansporter_Status" v-model="header.Tansporter_Status" type="text"
                                    placeholder="Tansporter Status" v-if="header" :disabled="isDisable" /> -->
                                <Dropdown v-model="header.Transporter_Status" :showClear="true"
                                            :options="transporterStatus" optionLabel="label" optionValue="value"
                                            :placeholder="$t('transporter_status')" v-if="header" :disabled="isDisable" />
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col-12">
                            <Fieldset legend="Condition" :toggleable="true">
                                <DataTable :loading="!header" v-if="header"
                                    :value="header.Condition ? header.Condition : null" responsiveLayout="scroll"
                                    class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                                    <Column style="width:30px">
                                        <template #header="">
                                            <Button label="" icon="pi pi-plus"
                                                class="p-button-primary p-mr-2 p-button-sm" @click="addCondition"
                                                :disabled="isDisable || header.Is_Deleted" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Time_From" :header="$t('time_from')">
                                        <template #body="slotProps">
                                            <DatePicker hourFormat="24" :showTime="true" :timeOnly="true"
                                                momentFormat="DD/MM/YYYY" dateFormat="dd/mm/yy" class="p-inputtext-sm"
                                                v-model="slotProps.data[slotProps.column.props.field]"
                                                @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Time_To" :header="$t('time_to')">
                                        <template #body="slotProps">
                                            <DatePicker hourFormat="24" :showTime="true" :timeOnly="true"
                                                momentFormat="DD/MM/YYYY" dateFormat="dd/mm/yy" class="p-inputtext-sm"
                                                v-model="slotProps.data[slotProps.column.props.field]"
                                                @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Use_Day" :header="$t('use_day')">
                                        <template #body="slotProps">
                                            <!-- <InputText name="Use_Day" 
                                                v-model="slotProps.data[slotProps.column.props.field]" type="text"
                                                :placeholder="$t('use_day')" @change="editCondition(slotProps)" :disabled="isDisable" /> -->
                                            <Dropdown v-model="slotProps.data[slotProps.column.props.field]" 
                                                :options="optionSelect" optionLabel="label" optionValue="value"
                                                :placeholder="$t('use_day')" @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Days" :header="$t('days')">
                                        <template #body="slotProps">
                                            <InputText name="Days" 
                                                v-model="slotProps.data[slotProps.column.props.field]" type="text"
                                                :placeholder="$t('days')" @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Time_Set" :header="$t('time_set')">
                                        <template #body="slotProps">
                                            <DatePicker hourFormat="24" :showTime="true" :timeOnly="true"
                                                momentFormat="DD/MM/YYYY" dateFormat="dd/mm/yy" class="p-inputtext-sm"
                                                v-model="slotProps.data[slotProps.column.props.field]"
                                                @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Use_Hour" :header="$t('use_hour')">
                                        <template #body="slotProps">
                                            <!-- <InputText name="Use_Hour" 
                                                v-model="slotProps.data[slotProps.column.props.field]" type="text"
                                                :placeholder="$t('use_hour')" @change="editCondition(slotProps)" :disabled="isDisable" /> -->
                                            <Dropdown v-model="slotProps.data[slotProps.column.props.field]" 
                                                :options="optionSelect" optionLabel="label" optionValue="value"
                                                :placeholder="$t('use_hour')" @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                    <Column field="Hours" :header="$t('hours')">
                                        <template #body="slotProps">
                                            <InputText name="Hours" 
                                                v-model="slotProps.data[slotProps.column.props.field]" type="text"
                                                :placeholder="$t('hours')" @change="editCondition(slotProps)" :disabled="isDisable" />
                                        </template>
                                    </Column>
                                </DataTable>
                            </Fieldset>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
    export default {
        name: "Editor",
        data() {
            return {
                indexName: "AutoRejectSettingIndex",
                url: this.$API_URL + "AutoRejectSetting/",
                validateError: [],
                header: null,
                detail: null,
                condition: null,
                mode: "",
                isDeleted: false,
                id: 0,
                formEditable: true,
                optionStatus: [
                    {value: "ASSIGNED TO TRANSPORTER", label: "ASSIGNED TO TRANSPORTER"}
                ],
                transporterStatus: [
                    {value: "ACCEPTED", label: "ACCEPTED"}
                ],
                optionSelect: [
                    {value: true, label: "Y"},
                    {value: false, label: "N"}
                ]
            }
        },
        methods: {
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                        self.condition = response.data.data.condition;
                        self.header.mode = self.mode;
                        self.isDeleted = self.header.Is_Deleted;
                    })
                    .catch(function (error) {
                        console.log("DATA");
                        alert(error);

                    });
            },
            saveData() {
                // console.log(validations)
                // return;

                this.validateForm();
                if(this.validateError.length > 0){
                    this.validateError.forEach(value => {
                        this.showError("Validation Error", value);
                    });
                    this.validateError = [];
                    return;
                }

                this.$emit('block-ui');
                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            this.$router.push({
                                name: this.indexName,
                                params: {
                                    showToast: true,
                                    severity: 'success',
                                    summary: 'Data Saved',
                                    detail: "Auto Reject Setting has been saved successfully",
                                    life: 120000
                                }
                            });
                        } else {
                            this.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        this.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({
                    severity: 'error',
                    summary: summary,
                    detail: message,
                    life: 120000
                });
            },
            validateForm(){
                if(this.mode != this.$FORM_MODE_DELETE){
                    if(this.header.Company_Code == null){
                    this.validateError.push("Company Name is required.");
                    }
                    
                    if(this.header.Business_Segment_Code == null){
                        this.validateError.push("Product Category is required.");
                    }

                    if(this.header.Status == null){
                        this.validateError.push("Status is required.");
                    }
                }
            },
            backToIndex() {
                this.$router.push({
                    path: "/AutoRejectSetting/Index"
                });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            addCondition() {
                var newDetail = this.condition;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };
                // det.Time_From = new Date();
                // det.Time_To = new Date();
                // det.Time_Set = new Date();
                this.header.Condition.push(det);
                
            },
            deleteCondition(event) {
                if (event) {
                    var detail = this.header.Condition[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) this.header.Condition.splice(this.header.Condition.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            editCondition(event) {
                var index = event.index;
                if (this.header.Condition && this.header.Condition.length > 0) {
                    let m = this.header.Condition[index].mode;

                    if (m == this.$FORM_MODE_UNCHANGED) {
                        this.header.Condition[index].mode = this.$FORM_MODE_EDIT;
                    }
                }
            },
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();
        },
        computed: {
            isDisable() {
                return this.mode == this.$FORM_MODE_VIEW || this.mode == this.$FORM_MODE_DELETE ? true : false;
            }
        }
    }
</script>